/**
 * fpo-flocage.js
 * - Masque les champs FPO si le produit n'a pas le tag "Flocage"
 * - Met à jour le prix affiché quand les champs FPO sont remplis
 */
(function () {
  'use strict';

  const priceEl = document.querySelector('product-price');
  if (!priceEl) return;

  const hasFlocage = priceEl.dataset.hasFlocage === 'true';
  let basePrice = parseInt(priceEl.dataset.basePrice || '0', 10);

  const PRICE_SELECTORS = [
    '.price__current .money',
    '.price-item--regular',
    '.price-item--sale',
    '.price__current'
  ];

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
  }

  // ─── 1. Masquage si pas le tag Flocage ───────────────────────────────────
  if (!hasFlocage) {
    function hideFields() {
      document.querySelectorAll('.fpo-flocage-field').forEach(el => {
        const block = el.closest('.fpob-field-wrapper, .fpob-option, [class*="fpob-"], .shopify-app-block')
          || el.parentElement?.parentElement;
        if (block) block.style.setProperty('display', 'none', 'important');
      });
    }

    hideFields();
    const obs = new MutationObserver(hideFields);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 5000);
    return;
  }

  // ─── 2. Calcul du prix total ──────────────────────────────────────────────
  function updatePriceDisplay() {
    let extraCents = 0;
    // Les spans fpob-tb-price-* n'apparaissent que quand le champ est rempli
    document.querySelectorAll('[class*="fpob-tb-price-"]').forEach(span => {
      const raw = span.textContent.replace(/[^0-9,\.]/g, '').replace(',', '.');
      const val = parseFloat(raw);
      if (!isNaN(val)) extraCents += Math.round(val * 100);
    });

    const total = basePrice + extraCents;
    PRICE_SELECTORS.forEach(sel => {
      priceEl.querySelectorAll(sel).forEach(el => {
        el.textContent = formatMoney(total);
      });
    });
  }

  // ─── 3. Listeners sur le conteneur FPO ───────────────────────────────────
  function attachListeners() {
    const field = document.querySelector('.fpo-flocage-field');
    if (!field) return false;

    const container = field.closest('.shopify-app-block, form, section') || document.body;

    container.addEventListener('input', updatePriceDisplay);
    container.addEventListener('change', updatePriceDisplay);

    new MutationObserver(updatePriceDisplay).observe(container, {
      subtree: true,
      childList: true,
      characterData: true
    });

    updatePriceDisplay();
    return true;
  }

  if (!attachListeners()) {
    const domObs = new MutationObserver(() => {
      if (attachListeners()) domObs.disconnect();
    });
    domObs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => domObs.disconnect(), 8000);
  }

  // ─── 4. Mise à jour si changement de variant (taille, etc.) ──────────────
  document.addEventListener('variant:change', (e) => {
    if (e.detail?.variant?.price !== undefined) {
      basePrice = e.detail.variant.price;
      updatePriceDisplay();
    }
  });

})();